module.exports = __webpack_public_path__ + "static/media/arrow_bottom.feef3b36.svg";